import sho1 from "../assets/sho1.jpg";
import sho2 from "../assets/sho2.jpg";
import sho3 from "../assets/sho3.jpg";
import sho4 from "../assets/sho4.jpg";
import sho5 from "../assets/sho5.jpg";
import sho6 from "../assets/sho6.jpg";

export const discounts30 = {
  name: "dis30",
  items: [
    {
      image: sho5,
      model: "Branded-New-Shoes-2023",
      p: "2QF-6262XLP",
      price: "$199",
    },
    {
      image: sho6,
      name: "Notebook",
      model: "Latest-Shoes 2022",
      p: "70LO 40k60",
      price: "$480",
    },
    {
      image: sho1,
      name: "Head Phones",
      model: "GoldStar-shoes 2023",
      p: "JHTBUK",
      price: "$266",
    },
    {
      image: sho4,
      model: "Nike-Shoes-2019",
      p: " 456- 40k60",
      price: "$460",
    },
    {
      image: sho3,
      model: "Air-Shoes-2021",
      p: "725lku-210k6",
      price: "$521",
    },
    {
      image: sho2,
      model: "Branded Shoes 2023",
      p: "40klKPD45",
      price: "$138",
    },
  ],
};

export const discounts15 = {
  name: "dis15",
  items: [
    {
      image: sho4,
      model: "Branded-Nike-Shoes 2016 ",
      p: "2QF-621XLP",
      price: "$199",
    },
    {
      image: sho3,
      name: "Nike-SHoes Z51-70 ",
      model: "Original Shoes 2022",
      p: "40K6009",
      price: "$108",
    },
    {
      image: sho2,
      name: "GoldStart-shoes",
      model: "Latest-shoes-2022",
      p: "JHTBUK40k",
      price: "$345",
    },
    {
      image: sho1,
      model: "Branded-Shoes 2022",
      p: "70 4059695k60",
      price: "$230",
    },
    {
      image: sho6,
      model: "New-Branded-Shoes",
      p: "725lku-21560k6",
      price: "$105",
    },
    {
      image: sho5,
      model: "New-Nike Shoes-2023",
      p: "40kl-LOK-KPD45",
      price: "$780",
    },
  ],
};
export const discounts20 = {
  name: "dis20",
  items: [
    {
      image: sho3,

      model: "Gold-Start Shoes 2022 ",
      p: "2QF-621XLP",
      price: "$299",
    },
    {
      image: sho1,
      name: "MNKL-2024",
      model: "Air-Latest-shoes-2023",
      p: "70 40k60",
      price: "$178",
    },
    {
      image: sho5,
      name: "Head Phones",
      model: "Nike-Shoes2020",
      p: "JHTBUK-01",
      price: "$152",
    },
    {
      image: sho6,
      model: "Nepali-Magic-shoes 2023",
      p: "SlK 40k60",
      price: "$160",
    },
    {
      image: sho2,
      model: "Air-Shoes-2024",
      p: "725lku-210k6",
      price: "$399",
    },
    {
      image: sho4,
      model: "Nike-Shoes-2023",
      p: "40klKPD45 plk",
      price: "$225",
    },
  ],
};
export const discounts40 = {
  name: "dis40",
  items: [
    {
      image: sho6,

      model: "ASUS laptop inspire 2016",
      p: "2QF-621XLP-1203",
      price: "$493",
    },
    {
      image: sho5,
      name: "Notebook",
      model: "Notebook screen Z51-",
      p: "70 PLZ 40k60",
      price: "$511",
    },
    {
      image: sho4,
      name: "ASUS laptop inspire 2016",
      model: "Notebook screen Z51-",
      p: "JHTBUK-6320",
      price: "$280",
    },
    {
      image: sho2,
      model: "Notebook screen Z51-",
      p: "70 -120-40k60",
      price: "$208",
    },
    {
      image: sho3,
      model: "ASUS laptop inspire 2016",
      p: "725lku-210k6",
      price: "$799",
    },
    {
      image: sho1,
      model: "Notebook screen Z51-",
      p: "40klKPD45",
      price: "$351",
    },
  ],
};
